import moment from "moment";
import store from "../store/store";

export default (value, format) => {
  if (!value) {
    return null;
  }
  format =
    (format && store.state.locale.dateFormats[format]) ||
    store.state.locale.dateFormats.shortDate;
  return moment(value).format(format);
};
